import {
  Alert,
  datePresetOptions,
  FilterControl,
  FilterControlType,
  Page,
  Skeleton,
} from 'corso-admin-ui';
import { RollingDatePreset } from 'corso-types';
import { match } from 'ts-pattern';
import { useDashboardParams } from '../hooks/useDashboardParams';
import { homePresets, useValueHome } from './useValueHome';
import { ValueOverview } from './ValueOverview';

const options = datePresetOptions.filter(({ value }) =>
  homePresets.some((preset) => preset === value),
);

export const HomePage = () => {
  const { date, setDate } = useDashboardParams();
  // a custom range from another dashboard reads as the default, since the home offers presets only
  const preset =
    (date.kind === 'preset' &&
      homePresets.find((option) => option === date.preset)) ||
    RollingDatePreset.last30Days;
  const home = useValueHome(preset);

  return (
    <Page
      title="Home"
      size="fullWidth"
      overrideActions={
        <FilterControl
          filter={{
            id: 'date',
            type: FilterControlType.date,
            label: 'Date',
            verb: 'is',
            options,
            value: { kind: 'preset', preset },
          }}
          onChange={({ value }) => setDate(value)}
        />
      }
    >
      {match(home)
        .with({ status: 'pending' }, () => (
          <Skeleton.Rectangle height="360px" width="100%" />
        ))
        .with({ status: 'error' }, () => (
          <Alert
            variant="critical"
            heading="Failed to load. Please try again later."
          />
        ))
        .with({ status: 'success' }, ({ data }) => (
          <ValueOverview data={data} />
        ))
        .exhaustive()}
    </Page>
  );
};
